export interface Connection {
  id: number
  display_name: string
  connection_type: string
  source_key: string | null
  status: 'active' | 'paused' | 'removed' | 'unavailable'
  health: 'healthy' | 'failing' | 'needs_attention'
  needs_attention_reason: string | null
  needs_attention_since: string | null
  last_run_at: string | null
  last_run_status: string | null
  next_run_at: string | null
  unmatched_count: number
  error_count: number
  accounting_bridge: boolean
}
export type ConnectionResponse = { connections: Connection[] }
export type SortColumn = 'name' | 'last_run' | 'health'
export const unmatchedPath = '/settings/connections/unmatched'
export function connectionPath(row: Connection) {
  return row.accounting_bridge ? '/settings/accounting' : `/settings/connections/${row.id}`
}
/** The one map from a Connection type key to the name staff see. */
export const typeLabels: Record<string, string> = {
  woocommerce: 'WooCommerce',
  moodle: 'Moodle',
  xero: 'Xero',
  mailchimp: 'Mailchimp',
  quickbooks_online: 'QuickBooks Online',
  fake: 'Sample connection',
}
export function connectionTypeName(type: string) {
  return typeLabels[type] ?? type
}
